import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import RadioField from "../../../../shared/form/RadioField";
import CheckBoxField from "../../../../shared/form/CheckBoxField";
import React from "react";

const BacEvaluateCategoriesListing = ({
                                          errors,
                                          categories,
                                          variant,
                                          setSelectedCategoriesHandler,
                                          setSelectedVariant,
                                      }: any) => {

    return (
        <>
            {categories.map((category: any, index: any) => (
                <Box key={index} mb={2}>
                    <Typography variant="h4">
                        {category.name}
                    </Typography>
                    {category.description && (
                        <Typography variant="h5" mb={1}>{category.description}</Typography>
                    )}
                    {category.subcategories?.length === 0 ? (
                        <Typography>Nu sunt itemi pentru selecția curentă.</Typography>
                    ) : (
                        category.mode === "radio" ? (
                            <RadioField
                                row={true}
                                name="variant"
                                columns={false}
                                defaultValue={variant}
                                onChange={setSelectedVariant}
                                options={category.subcategories.map((item: {
                                    name: string;
                                    id: string
                                }) => {
                                    return {
                                        label: item.name,
                                        value: item.id.toString(),
                                        ...item,
                                    };
                                })}
                            />
                        ) : (
                            <CheckBoxField
                                name="chapters"
                                type="checkbox-group"
                                label="Alege capitolele"
                                labelPlacement="end"
                                options={category.subcategories?.map(
                                    (item: {
                                        name: string;
                                        id: string;
                                        description: string;
                                        [key: string]: any
                                    }) => {
                                        return {
                                            label: item.name,
                                            value: item.id,
                                            disabled: variant !== "",
                                            ...item,
                                        };
                                    },
                                )}
                                onChange={(e) => setSelectedCategoriesHandler(e, index)}
                            />
                        )
                    )}
                </Box>
            ))}
        </>
    )
}

export default BacEvaluateCategoriesListing;